import { useRecoilValue, useRecoilCallback } from 'recoil'
import {
  selectedItemAtom,
  itemAtomFamily,
  itemIdAtom,
  unsavedChangesAtom,
} from 'atoms'
import { v4 as uuidv4 } from 'uuid'

export const useDuplicateItem = () => {
  const selectedItem = useRecoilValue(selectedItemAtom)
  const itemIds = useRecoilValue(itemIdAtom)
  const item = useRecoilValue(itemAtomFamily(selectedItem))

  const duplicateItem = () => {
    // With no sole selection the source is the family's empty default, and
    // its copy would be an item that never renders.
    if (!item?.type) return
    const duplicatedItem = { ...item }
    const uuid = uuidv4()

    duplicatedItem.id = uuid
    duplicatedItem.x = parseInt(duplicatedItem.x) + 10
    duplicatedItem.y = parseInt(duplicatedItem.y) + 10
    addItem(duplicatedItem)
  }

  const addItem = useRecoilCallback(({ set }) => (duplicatedItem) => {
    set(itemAtomFamily(duplicatedItem.id), duplicatedItem)
    set(itemIdAtom, [...itemIds, duplicatedItem.id])
    set(unsavedChangesAtom, true)
  })

  return () => duplicateItem()
}

export default useDuplicateItem
